import { type Store } from "@/types";

export const newLocalStorageStore = (
  window: Window,
  keyPrefix: string,
): Store => ({
  get: async (key: string) =>
    window?.localStorage?.getItem([keyPrefix, key].join("_")),
  set: async (key: string, value: string) =>
    window?.localStorage?.setItem([keyPrefix, key].join("_"), value),
});
